<template>
  <b-modal
    ref="confirmation"
    content-class="px-none px-lg-3"
    :id="modalId"
    :title="displayName"
    centered
    hide-header-close
    footer-class="text-center"
  >
    {{prompt}}
    <div slot="modal-footer" class="d-flex full-width">
      <b-button
        pill
        variant="danger"
        class="mr-3"
        @click="hideModal"
        aria-label="Cancel action">
        No
      </b-button>
      <b-button
        pill
        variant="primary"
        @click="onConfirmed()"
        aria-label="Confirm action">
        Yes
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ConfirmModal',
  props: {
    modalId: {
      type: String,
      required: true,
    },
    prompt: {
      type: String,
      default() {
        return 'Are you sure you?';
      },
    },
    displayName: {
      type: String,
      default() {
        return 'Cancel';
      },
    },
  },
  methods: {
    hideModal() {
      this.$refs.confirmation.hide();
    },
    onConfirmed() {
      this.$refs.confirmation.hide();
      this.$emit('onConfirmed');
    },
  },
};
</script>
